import React from 'react'

import cm from './ScreenshotFrame.module.css'

interface ScreenshotFrameProps {
  children: React.ReactNode
}

export const ScreenshotFrame = React.forwardRef<HTMLDivElement, ScreenshotFrameProps>(
  (props: ScreenshotFrameProps, ref) => {
    return (
      <div ref={ref} className={cm.container}>
        {props.children}
      </div>
    )
  },
)
